module.exports = __webpack_public_path__ + "assets/img/29_304.f5a17a0a.jpg";